<div class="notification-box" (click)="toggleNotificationMobile()">
  <svg>
    <use href="assets/svg/icon-sprite.svg#notification"></use>
  </svg>
  <span class="badge rounded-pill badge-secondary">{{ '4' | translate }}</span>
</div>
<div class="onhover-show-div notification-dropdown">
  <h6 class="f-18 mb-0 dropdown-title">{{ 'Notitications' | translate }}</h6>
  <ul>
    <li class="b-l-primary border-4">
      <p>{{ 'Delivery processing ' | translate }}<span class="font-danger">{{ '10 min.' | translate }}</span></p>
    </li>
    <li class="b-l-success border-4">
      <p>{{ 'Order Complete' | translate }}<span class="font-success">{{ '1 hr' | translate }}</span></p>
    </li>
    <li class="b-l-secondary border-4">
      <p>{{ 'Tickets Generated' | translate }}<span class="font-secondary">{{ '3 hr' | translate }}</span></p>
    </li>
    <li class="b-l-warning border-4">
      <p>{{ 'Delivery Complete' | translate }}<span class="font-warning">{{ '6 hr' | translate }}</span></p>
    </li>
    <li><a class="f-w-700" href="#">{{ 'Check all' | translate }}</a></li>
  </ul>
</div>
